import React from 'react'

import styles from './formItemsInline.module.scss'

const FormItemsInline = props => {
  return (
    <div className={styles.container_formItemsInline}>
      {
        props.children.length > 1
          ? props.children.map((item, index) => {
            return !!item
              ? <div className={styles.container_formItemInline} key={index}>
                {item}
              </div>
              : null
          })
          : <div className={styles.container_formItemInline}>
            {props.children}
          </div>
      }
    </div>
  )
}

export default React.memo(FormItemsInline)